define(function (require) {
    "use strict";

    //required libs
    var LE = require("app");
    //Models
    var LPAuthModel = require("manager-models/data-sources/integrations/authentication/types/LPAuthModel");
    var OAuth2CodeModel = require("manager-models/data-sources/integrations/authentication/types/OAuth2CodeModel");
    var OAuth2ImplicitModel = require("manager-models/data-sources/integrations/authentication/types/OAuth2ImplicitModel");

    var AuthenticationTypeModelBuilder = {};

    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {

        var AuthModelMap = {
            0 : LPAuthModel,
            1 : OAuth2ImplicitModel,
            2 : OAuth2CodeModel
        };

        AuthenticationTypeModelBuilder.createModelByType = function (type, attrs, options) {
            var Model  =  AuthModelMap[type];

            if (_.isUndefined(Model)) {
                LEManager.logger.error("No AuthModel found for type " + type,"AuthenticationTypeModelBuilder::createModelByType");
                LEManager.logger.graph({name: "manager:AuthenticationTypeModelBuilder:createModelByType:NoModelForType"});
                return "NO_MODEL_FOUND";
            }

            return new (AuthModelMap[type])(attrs, options);

        };

    }

    LE.module("LEManager", moduleDefinition);

    return AuthenticationTypeModelBuilder;
});
